<template>
  <ul class="nav nav-tabs header-tabs noPrint profile-nav-container">
    <li
      v-for="link in resolved.bar"
      :key="link.key"
      :class="['nav-item', { dropdown: !!link.dropdown }, link.class]"
    >
      <a
        class="nav-link dropdown-toggle"
        href="#"
        role="button"
        data-toggle="dropdown"
        v-if="link.dropdown"
      >
        <icon v-if="link.icon" :type="link.icon" class="mr-1" />
        <img
          v-if="link.image"
          :src="link.image.src"
          :width="link.image.width"
          :height="link.image.height"
          class="mr-1"
        />
        {{ link.label }}
      </a>
      <div class="dropdown-menu" v-if="link.dropdown">
        <router-link
          v-for="drop in link.dropdown"
          :key="drop.label"
          :to="getLink(drop.to, drop.query)"
          class="dropdown-item"
          :class="name == drop.to ? `active` : ``"
        >
          <icon v-if="drop.icon" :type="drop.icon" class="mr-1" />
          <img
            v-if="drop.image"
            :src="drop.image.src"
            :width="drop.image.width"
            :height="drop.image.height"
            class="mr-1"
          />
          {{ drop.label }}
        </router-link>
      </div>

      <profile-nav-item
        v-if="!link.dropdown"
        :item="link"
        :get-link="getLink"
        :badges="badges"
        :route-name="name"
        link-class="nav-link"
        @action="$emit('action', $event)"
      />
    </li>

    <!-- floating-vue, not a Bootstrap dropdown: the tab strip is overflow-hidden
         below 1025px, so an inline menu would be clipped. -->
    <li v-if="resolved.more.length" class="nav-item profile-nav-more">
      <Dropdown
        :distance="2"
        placement="bottom-end"
        :triggers="['click']"
        :auto-hide="true"
        popper-class="profile-nav-more-popper"
      >
        <a
          class="nav-link dropdown-toggle"
          :class="moreHasActiveChild ? 'active' : ''"
          href="#"
          role="button"
          aria-haspopup="true"
          @click.prevent
        >
          <icon type="ellipsis-h" class="mr-1" />
          {{ moreLabel }}
          <span
            v-if="moreNeedsAttention"
            class="profile-nav-more-dot ml-1"
            title="Items needing attention under More"
          ></span>
        </a>

        <template #popper>
          <div class="profile-nav-more-menu">
            <!-- v-close-popper: floating-vue does not close on a click inside the popper. -->
            <profile-nav-item
              v-for="link in resolved.more"
              :key="link.key"
              v-close-popper
              :item="link"
              :get-link="getLink"
              :badges="badges"
              :route-name="name"
              link-class="dropdown-item"
              @action="$emit('action', $event)"
            />
          </div>
        </template>
      </Dropdown>
    </li>
  </ul>
</template>
<script>
import { Dropdown } from "floating-vue";
import {
  isAnyProfileNavItemActive,
  resolveProfileNav,
} from "./profileNavResolver";

export default {
  name: "ProfileNavbar",
  // floating-vue does not globally register the bare `Dropdown` name.
  components: { Dropdown },
  props: {
    items: {
      type: Array,
      required: true,
    },
    getLink: {
      type: Function,
      required: true,
    },
    badges: {
      type: Object,
      default: () => ({}),
    },
    config: {
      type: Object,
      default: null,
    },
    moreLabel: {
      type: String,
      default: "More",
    },
  },
  emits: ["action"],
  computed: {
    name: function () {
      return this.$route.name;
    },
    resolved: function () {
      return resolveProfileNav(this.items, this.config);
    },
    moreHasActiveChild: function () {
      return isAnyProfileNavItemActive(this.resolved.more, this.name);
    },
    // A dot, not a total: exact counts stay on the items inside the menu.
    moreNeedsAttention: function () {
      return this.resolved.more.some((item) => {
        const badge = this.badges[item.badgeKey];
        return !!(badge && !badge.loading && badge.value);
      });
    },
  },
};
</script>

<style lang="scss">
/* Not scoped: the popper renders at <body>, outside this component's DOM. */
.profile-nav-more-popper .v-popper__inner {
  padding: 0;
  background: #fff;
  color: inherit;
  border-radius: 0.375rem;
  box-shadow: 0 0.5rem 1rem rgba(18, 38, 63, 0.175);
  overflow: hidden;
}

.profile-nav-more-popper .v-popper__arrow-container {
  display: none;
}

.profile-nav-more-menu {
  min-width: 12rem;
  max-height: 70vh;
  overflow-y: auto;
  padding: 0.5rem 0;
}

.profile-nav-more-menu .dropdown-item {
  display: block;
  width: 100%;
  padding: 0.375rem 1.25rem;
  clear: both;
  font-weight: 400;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.profile-nav-more-menu .dropdown-item.active {
  font-weight: 600;
}

.profile-nav-more .profile-nav-more-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #dc3545;
  vertical-align: middle;
}
</style>
